import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'lemsar-register-type-component',
    templateUrl: './register-type.component.html',
    styleUrls: ['./register-type.component.scss'],
})
export class RegisterTypeComponent implements OnInit {
    @Output() public typeChanges: EventEmitter<any> = new EventEmitter();

    @Input() public hasTitle = false;
    @Input() public selectedType: string = 'landing';
    @Input() public isUpdate = false;
    @Input() public institutionType: string;

    public selectedTypeObj: any;

    public government = 'government';
    public private = 'private';
    public industrial = 'industrial';
    public community = 'community';

    public types = [
        {
            value: this.government,
            icon: 'university',
            title: 'Lembaga Pemerintah',
            desc: 'Pendaftaran untuk BLK UPTP, BLK UPTD dan Lembaga Pelatihan K/L.',
        },
        {
            value: this.private,
            icon: 'building',
            title: 'Lembaga Swasta',
            desc: 'Pendaftaran untuk LPK Swasta, BLKLN.',
        },
        {
            value: this.industrial,
            icon: 'industry',
            title: 'Industri',
            desc:
                'Pendaftaran untuk lembaga pelatihan yang ada di perusahaan. Untuk tipe lembaga ini wajib sudah terdaftar di layanan wajib lapor ketenagakerjaan.',
        },
        {
            value: this.community,
            icon: 'users',
            title: 'BLK Komunitas',
            desc: 'Pendaftaran untuk BLK Komunitas.',
        },
    ];

    public ngOnInit() {
        if (this.selectedType === 'landing') {
            return;
        }
        this.onSelectType(this.types.find(item => item.value === this.selectedType));
    }

    public onSelectType(typeObj: any) {
        this.selectedType = typeObj.value;
        this.selectedTypeObj = typeObj;
        this.typeChanges.emit(this.selectedType);
    }
}



// WEBPACK FOOTER //
// ./src/lemsar/auth/views/components/register-type/register-type.component.ts